import { render, staticRenderFns } from "./ResponsiveWave.vue?vue&type=template&id=27267dde&scoped=true&"
import script from "./ResponsiveWave.vue?vue&type=script&lang=ts&"
export * from "./ResponsiveWave.vue?vue&type=script&lang=ts&"
import style0 from "./ResponsiveWave.vue?vue&type=style&index=0&id=27267dde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27267dde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
